import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/exam/time.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2de15abc"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "QuestionCard"
};
var _hoisted_2 = {
  key: 0,
  class: "title"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "距离考试结束：", -1);
});

var _hoisted_5 = {
  key: 0,
  class: "time"
};
var _hoisted_6 = {
  key: 1,
  class: "title-top"
};
var _hoisted_7 = ["onClick"];
var _hoisted_8 = {
  class: "no-cursor"
};
var _hoisted_9 = {
  key: 2,
  class: "title-box"
};
var _hoisted_10 = ["onClick"];
var _hoisted_11 = {
  class: "swiper-container swiper-no-swiping"
};
var _hoisted_12 = {
  class: "swiper-wrapper"
};
var _hoisted_13 = {
  ref: "Ref_slideBox",
  class: "slide-box"
};
var _hoisted_14 = {
  class: "topic Public-Flex-OnlyAlCenter"
};
var _hoisted_15 = {
  class: "type-title-new Public-Flex-Center"
};
var _hoisted_16 = {
  class: "topic-box"
};
var _hoisted_17 = {
  class: "slide-title"
};
var _hoisted_18 = {
  key: 0
};
var _hoisted_19 = {
  key: 1
};
var _hoisted_20 = ["for"];
var _hoisted_21 = ["for"];

var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString(""), -1);
});

var _hoisted_23 = [_hoisted_22];

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-left": "10px"
    }
  }, [/*#__PURE__*/_createElementVNode("label", {
    for: "inputHTML"
  }, /*#__PURE__*/_toDisplayString(""))], -1);
});

var _hoisted_25 = ["id", "onUpdate:modelValue", "maxlength", "disabled"];
var _hoisted_26 = {
  key: 3
};
var _hoisted_27 = {
  key: 0,
  class: "type tpye-select"
};
var _hoisted_28 = {
  key: 1,
  class: "type tpye-select"
};
var _hoisted_29 = ["src"];
var _hoisted_30 = {
  class: "disabled-text"
};
var _hoisted_31 = {
  key: 2,
  class: "type tpye-select"
};

var _hoisted_32 = /*#__PURE__*/_createTextVNode(" 对 ");

var _hoisted_33 = /*#__PURE__*/_createTextVNode(" 错 ");

var _hoisted_34 = {
  class: "swipe-handle"
};

var _hoisted_35 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "el-icon-arrow-left"
  }, null, -1);
});

var _hoisted_36 = /*#__PURE__*/_createTextVNode("上一题 ");

var _hoisted_37 = [_hoisted_35, _hoisted_36];

var _hoisted_38 = /*#__PURE__*/_createTextVNode(" 下一题");

var _hoisted_39 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "el-icon-arrow-right"
  }, null, -1);
});

var _hoisted_40 = [_hoisted_38, _hoisted_39];
var _hoisted_41 = {
  class: "handleSubmit"
};
var _hoisted_42 = {
  key: 1,
  class: "handleSubmit"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_radio = _resolveComponent("el-radio");

  var _component_el_radio_group = _resolveComponent("el-radio-group");

  var _component_EndAnswer = _resolveComponent("EndAnswer");

  var _component_el_checkbox = _resolveComponent("el-checkbox");

  var _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

  var _component_NingTips = _resolveComponent("NingTips");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.disabled == true && _ctx.isTime == true ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _hoisted_4, _ctx.timeTF == true ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.Data.listTime.duration) + "分钟 ", 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _ctx.arrive != '知识测试' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.questionArr, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: item.id,
      class: _normalizeClass({
        active: item.isActive == true,
        'is-display': item.children.length == 0
      }),
      onClick: function onClick($event) {
        return _ctx.tabsClick(item, index);
      }
    }, _toDisplayString(item.title), 11, _hoisted_7);
  }), 128)), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(_ctx.isQuestionType(_ctx.Data.questionArrIndex + 1)), 1), _createTextVNode(" 分值：每题" + _toDisplayString(_ctx.listscore[Object.keys(_ctx.listscore)[_ctx.Data.questionArrIndex]]) + "分 总分：" + _toDisplayString(_ctx.getFullScore(_ctx.Data.questionArr[_ctx.Data.questionArrIndex], _ctx.listscore[Object.keys(_ctx.listscore)[_ctx.Data.questionArrIndex]])) + "分 ", 1)])])) : _createCommentVNode("", true), _ctx.arrive != '知识测试' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.questionArr[_ctx.Data.questionArrIndex].children, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass({
        isActive: Number(item) - 1 == _ctx.Data.mySwiperIndex
      }),
      onClick: function onClick($event) {
        return _ctx.titleClick(Number(item));
      }
    }, _toDisplayString(item), 11, _hoisted_10);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.questionList, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: item.id,
      class: "swiper-slide"
    }, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", null, _toDisplayString(_ctx.isQuestionType(item.type)), 1)]), _createElementVNode("span", null, "第" + _toDisplayString(index + 1) + "题", 1)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [item.type != 4 ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(item.title), 1)) : _createCommentVNode("", true), item.type == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(item.title.split("()")[0]), 1)) : _createCommentVNode("", true), item.type == 4 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.questionList[index].answerArr, function (itemInput, indexInput) {
      return _openBlock(), _createElementBlock("div", {
        key: itemInput,
        class: _normalizeClass(["input-box", {
          'span-other': indexInput == _ctx.Data.questionList[index].answer.length - 1,
          'is-input-focus': _ctx.Data.isInputState == 'focus',
          'is-input-blur': _ctx.Data.isInputState == 'blur',
          'is-input-error': item.reply != item.answer,
          'is-input-right': item.reply == item.answer
        }])
      }, [_createElementVNode("label", {
        for: 'inputHTML' + index
      }, [_createElementVNode("span", null, _toDisplayString(itemInput), 1)], 8, _hoisted_20)], 2);
    }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.questionList[index].answer.length - _ctx.Data.questionList[index].answerArr.length, function (itemInputOther, indexInputOther) {
      return _openBlock(), _createElementBlock("div", {
        key: itemInputOther,
        class: _normalizeClass(["input-box", {
          'input-other': indexInputOther == 0,
          'is-input-focus': _ctx.Data.isInputState == 'focus',
          'is-input-blur': _ctx.Data.isInputState == 'blur'
        }])
      }, [_createElementVNode("label", {
        for: 'inputHTML' + index
      }, _hoisted_23, 8, _hoisted_21)], 2);
    }), 128)), _hoisted_24, _withDirectives(_createElementVNode("input", {
      id: 'inputHTML' + index,
      "onUpdate:modelValue": function onUpdateModelValue($event) {
        return _ctx.Data.questionList[index].answerArr = $event;
      },
      autocomplete: "off",
      maxlength: _ctx.Data.questionList[index].answer.length,
      type: "text",
      disabled: !_ctx.disabled,
      onBlur: _cache[0] || (_cache[0] = function ($event) {
        return _ctx.isInputClick('blur');
      }),
      onFocus: _cache[1] || (_cache[1] = function ($event) {
        return _ctx.isInputClick('focus');
      })
    }, null, 40, _hoisted_25), [[_vModelText, _ctx.Data.questionList[index].answerArr]])], 64)) : _createCommentVNode("", true), item.type == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(item.title.split("()")[1]), 1)) : _createCommentVNode("", true)])]), item.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_ctx.disabled ? (_openBlock(), _createBlock(_component_el_radio_group, {
      key: 0,
      modelValue: _ctx.Data.answer[index].answer,
      "onUpdate:modelValue": function onUpdateModelValue($event) {
        return _ctx.Data.answer[index].answer = $event;
      }
    }, {
      default: _withCtx(function () {
        return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, function (itemChildren, indexChildren) {
          return _openBlock(), _createBlock(_component_el_radio, {
            key: itemChildren.id,
            label: String(indexChildren + 1),
            disabled: !_ctx.disabled
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.Data.alphabet[indexChildren]) + "." + _toDisplayString(itemChildren.answerName), 1)];
            }),
            _: 2
          }, 1032, ["label", "disabled"]);
        }), 128))];
      }),
      _: 2
    }, 1032, ["modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), !_ctx.disabled ? (_openBlock(), _createBlock(_component_EndAnswer, {
      key: 1,
      type: 1,
      reply: item.reply,
      answer: item.answer,
      alphabet: _ctx.Data.alphabet,
      options: item.options
    }, null, 8, ["reply", "answer", "alphabet", "options"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), item.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_ctx.disabled ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
      key: 0,
      modelValue: _ctx.Data.answer[index].answer,
      "onUpdate:modelValue": function onUpdateModelValue($event) {
        return _ctx.Data.answer[index].answer = $event;
      }
    }, {
      default: _withCtx(function () {
        return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, function (itemChildren, indexChildren) {
          return _openBlock(), _createBlock(_component_el_checkbox, {
            key: itemChildren.id,
            label: String(indexChildren + 1),
            disabled: !_ctx.disabled
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.Data.alphabet[indexChildren]) + "." + _toDisplayString(itemChildren.answerName), 1)];
            }),
            _: 2
          }, 1032, ["label", "disabled"]);
        }), 128))];
      }),
      _: 2
    }, 1032, ["modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), !_ctx.disabled ? (_openBlock(true), _createElementBlock(_Fragment, {
      key: 1
    }, _renderList(item.options, function (itemChildren, indexChildren) {
      return _openBlock(), _createElementBlock("div", {
        key: itemChildren.id,
        class: "disabled-box"
      }, [_createElementVNode("div", null, [_createElementVNode("img", {
        class: "1",
        src: require("../../assets/img/exam/square-".concat(_ctx.selectImage(indexChildren, _ctx.Data.questionList[index]).name, ".png")),
        alt: ""
      }, null, 8, _hoisted_29)]), _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.Data.alphabet[indexChildren]) + "." + _toDisplayString(item.options[indexChildren].answerName), 1)]);
    }), 128)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), item.type == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_ctx.disabled ? (_openBlock(), _createBlock(_component_el_radio_group, {
      key: 0,
      modelValue: _ctx.Data.answer[index].answer,
      "onUpdate:modelValue": function onUpdateModelValue($event) {
        return _ctx.Data.answer[index].answer = $event;
      },
      disabled: !_ctx.disabled
    }, {
      default: _withCtx(function () {
        return [_createVNode(_component_el_radio, {
          label: '0'
        }, {
          default: _withCtx(function () {
            return [_hoisted_32];
          }),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: '1'
        }, {
          default: _withCtx(function () {
            return [_hoisted_33];
          }),
          _: 1
        })];
      }),
      _: 2
    }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true), !_ctx.disabled ? (_openBlock(), _createBlock(_component_EndAnswer, {
      key: 1,
      type: 3,
      reply: item.reply,
      answer: item.answer,
      alphabet: _ctx.Data.alphabet,
      options: item.options
    }, null, 8, ["reply", "answer", "alphabet", "options"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 512), _ctx.disabled == false ? (_openBlock(), _createBlock(_component_NingTips, {
      key: 0,
      detail: {
        right: item.answer,
        left: item.reply,
        intro: item.intro
      },
      alphabet: _ctx.Data.alphabet,
      istype: item.type
    }, null, 8, ["detail", "alphabet", "istype"])) : _createCommentVNode("", true)]);
  }), 128))]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", {
    class: _normalizeClass(["swiper-button-prev swiper-button-public", {
      'swiper-button-none': _ctx.Data.mySwiperIndex == 0
    }]),
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.toggledSwiper('prev');
    })
  }, _hoisted_37, 2), _ctx.isNext ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["swiper-button-next swiper-button-public", {
      'swiper-button-none': _ctx.Data.mySwiperIndex == _ctx.Data.questionList.length - 1
    }]),
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.toggledSwiper('next');
    })
  }, _hoisted_40, 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_41, [_withDirectives(_createElementVNode("div", {
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return _ctx.handleSubmit(true);
    })
  }, " 交卷 ", 512), [[_vShow, _ctx.disabled == true]])]), _ctx.state == 'detail' && _ctx.from == 'mistakes' ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_createElementVNode("div", {
    onClick: _cache[5] || (_cache[5] = //@ts-ignore
    function () {
      return _ctx.handleMove && _ctx.handleMove.apply(_ctx, arguments);
    })
  }, " 移出 ")])) : _createCommentVNode("", true)])])]);
}